import { MultilingualWidgetConfig } from '../dashboard.widgets.config';

interface DateInfo {
  date: {
    en: string;
    de: string;
  };
}

interface StaffMember {
  initials: string;
  name: {
    en: string;
    de: string;
  };
  department: {
    en: string;
    de: string;
  };
  extension: string;
  extensionPrefix: {
    en: string;
    de: string;
  };
  color: string;
}

interface FooterText {
  totalStaff: {
    en: string;
    de: string;
  };
  viewAll: {
    en: string;
    de: string;
  };
}

interface HeaderText {
  title: {
    en: string;
    de: string;
  };
}

// Data for the staff directory
const dateInfo: DateInfo = {
  date: {
    en: 'March 15, 2025',
    de: '15. März 2025',
  },
};

const headerText: HeaderText = {
  title: {
    en: 'On-Call Staff',
    de: 'Bereitschaftspersonal',
  },
};

const staffMembers: StaffMember[] = [
  {
    initials: 'JD',
    name: {
      en: 'Dr. Jane Davis',
      de: 'Dr. Julia Müller',
    },
    department: {
      en: 'Cardiology',
      de: 'Kardiologie',
    },
    extension: '4532',
    extensionPrefix: {
      en: 'Ext.',
      de: 'Durchwahl',
    },
    color: '#434ce8',
  },
  {
    initials: 'MP',
    name: {
      en: 'Dr. Michael Patel',
      de: 'Dr. Michael Schmidt',
    },
    department: {
      en: 'Emergency',
      de: 'Notfall',
    },
    extension: '4099',
    extensionPrefix: {
      en: 'Ext.',
      de: 'Durchwahl',
    },
    color: '#10b981',
  },
  {
    initials: 'SL',
    name: {
      en: 'Sarah Lee, RN',
      de: 'Sabine Wagner, PK',
    },
    department: {
      en: 'ICU',
      de: 'ITS',
    },
    extension: '4211',
    extensionPrefix: {
      en: 'Ext.',
      de: 'Durchwahl',
    },
    color: '#f59e0b',
  },
];

const footerText: FooterText = {
  totalStaff: {
    en: 'Total staff on call: 12',
    de: 'Gesamtes Bereitschaftspersonal: 12',
  },
  viewAll: {
    en: 'View All',
    de: 'Alle anzeigen',
  },
};

const generateDirectoryHtml = (language: 'en' | 'de'): string => {
  // Generate staff member cards
  const staffMembersHtml = staffMembers
    .map(
      member => `
      <div style="display: flex; align-items: center; padding: 10px; background-color: #ecf3fe; border-radius: 8px;">
        <div style="width: 40px; height: 40px; border-radius: 50%; background-color: ${member.color}; display: flex; align-items: center; justify-content: center; color: white; font-weight: 500; margin-right: 12px;">${member.initials}</div>
        <div>
          <div style="font-weight: 500;">${member.name[language]}</div>
          <div style="font-size: 0.85rem; color: #686b87;">${member.department[language]} • ${member.extensionPrefix[language]} ${member.extension}</div>
        </div>
      </div>
    `,
    )
    .join('');

  return `
    <div style="display: flex; flex-direction: column; height: 100%; font-family: 'Be Vietnam Pro', sans-serif; color: #282a32;">
      <div style="margin-bottom: 12px; display: flex; justify-content: space-between; align-items: center;">
        <div style="font-weight: 600; color: #282a32;">${headerText.title[language]}</div>
        <div style="font-size: 0.85rem; color: #686b87;">${dateInfo.date[language]}</div>
      </div>
      <div style="display: flex; flex-direction: column; gap: 10px; margin-bottom: 12px;">
        ${staffMembersHtml}
      </div>
      <div style="text-align: center; font-size: 0.85rem; color: #686b87;">${footerText.totalStaff[language]} • <span style="color: #434ce8; font-weight: 500; cursor: pointer;">${footerText.viewAll[language]}</span></div>
    </div>`;
};

export const staffDirectoryWidget: MultilingualWidgetConfig = {
  id: 'staff-directory',
  translations: {
    en: {
      title: 'Staff Directory',
      content: generateDirectoryHtml('en'),
    },
    de: {
      title: 'Personalverzeichnis',
      content: generateDirectoryHtml('de'),
    },
  },
  x: 4,
  y: 8,
  w: 2,
  h: 3,
};
